import * as React from 'react';
import { HttpService, SystemGrid } from 'library';
import { IFormData, IFormState, SystemFormDetail } from 'library/form/SystemFormDetail';
import { useContext, useState } from 'react';
import { GridColumn as Column } from '@progress/kendo-react-grid';
import { scoreContext } from './ProjectScoreCard';

interface IDataModel extends IFormData {
    PrimaryKeyEncrypted?: string,
    Code?: string,
    Name?: string,
    Description?: string,
    Active?: boolean,
    ParentLocationId?: number,
    LeadLocationUserId?: number,
    LeadLocationUserLocationUserId?: number,
    RowVersion?: string,
    Total: number
}

let Total = 0;
let total0 = 0;
let totalless4 = 0;
let total10 = 0;
let arr: any[] = [];
let formData: any[] = [];

const StatusCell = (props: any) => {
    const value = props.dataItem[props.ScoreCardQuestionId as string];
    const score = props.dataItem["Score"]

    const { setTotalScore, setTotalTens, setTotalZero, setTotalLessThen4, OpportunityId, setData, setscoreCardGroupId } = useContext(scoreContext);

    const [status, SetStatus] = useState(score ? score : '');

    const handleInput = (event: any, dataItem: any) => {
        SetStatus(event.target.value);

        if (/^\d*$/.test(event.target.value) && event.target.value >= 0 && event.target.value <= 10 && event.target.value != "") {
            let obj = { "Id": event.target.name, "value": event.target.value }
            let item = arr.find((item) => item.Id == obj.Id);
            if (item) {
                arr = arr.filter(obj => obj !== item);
            }
            arr.push(obj);
            calculateScore();

            setscoreCardGroupId(dataItem.ScoreCardGroupId);
            let scoreData = { OpportunityId: OpportunityId, ScoreCardQuestionId: dataItem.ScoreCardQuestionId, Score: event.target.value };
            const existingRecord = formData.find((item) => item.ScoreCardQuestionId === scoreData.ScoreCardQuestionId);
            if (existingRecord)
                existingRecord.Score = scoreData.Score;
            else
                formData.push(scoreData);
            setData(formData);
        }
    }

    function calculateScore() {
        Total = 0;
        total0 = 0;
        totalless4 = 0;
        total10 = 0;

        for (var i = 0; i < arr.length; i++) {
            let val = parseInt(arr[i].value)
            if (val == 10) {
                total10++;
            }
            else if (val == 0) {
                total0++;
            }
            else if (val < 4) {
                totalless4++;
            }
            Total = Total + val;
        }

        setTotalScore(Total);
        setTotalTens(total10);
        setTotalZero(total0);
        setTotalLessThen4(totalless4);

        let element = document.getElementById("TotalScore");
        if (element) {
            element.value = Total
        }
    }
    return (
        <td><input type="number" id={"enterScore" + props.dataItem.ScoreCardQuestionId} disabled={props.dataItem.EditPermission} name={"enterScore" + props.dataItem.ScoreCardQuestionId} onChange={() => handleInput(event, props.dataItem)} value={status} /> </td>)
}

export default class ProjectScoreCardDetailForm extends SystemFormDetail<IDataModel> {
    constructor(props: any) {
        super(props);
        Total = props.dataItem.TotalScore
    }

    initial = (): IFormState<IDataModel> => {
        return {
            formData: {
                PrimaryKeyEncrypted: (this.props.data && this.props.data.PrimaryKeyEncrypted) ? this.props.data.PrimaryKeyEncrypted : undefined,
                Total: 0
            },
        }
    }

    load = (data: IDataModel) => {
        if (data) {
            this.setState({
                formData: {
                    ...data,
                    PrimaryKeyEncrypted: data.PrimaryKeyEncrypted,
                    Code: data.Code,
                    Name: data.Name,
                    Description: data.Description,
                    Active: data.Active,
                    ParentLocationId: data.ParentLocationId,
                    LeadLocationUserId: data.LeadLocationUserId,
                    LeadLocationUserLocationUserId: data.LeadLocationUserLocationUserId,
                    RowVersion: data.RowVersion
                }
            })
        }
    }

    render() {
        return (<>
            <scoreContext.Consumer>
                {({ OpportunityId }) => {
                    return (
                        <div className="table-responsive">
                        <SystemGrid
                            style={{ height: "420px" }}
                            resizable={true}
                            reorderable={true}
                            dataSource={"/ScoreCardVersionQuestion/ScoreCardVersionQuestionScoreByGroupId/" + this.props.dataItem.ScoreCardGroupId + "/" + OpportunityId}
                            schema="Top"
                            table="ScoreCardAnswers"
                            securityObject="Top.ScoreCardAnswers" >

                            <Column field="QuestionText" title={this.props.dataItem.SubName} width="200px" />
                            <Column title="Negative" width="200px">
                                <Column title="0" field="NegativeScoreText" cell={(props) => {
                                    return (<><td colSpan={4} >{props.dataItem.NegativeScoreText}</td></>)
                                }} />
                                <Column title="1" />
                                <Column title="2" />
                                <Column title="3" />
                            </Column>

                            <Column title="Normal" width="200px">
                                <Column title="4" field="NegativeScoreText" cell={(props) => { return (<><td colSpan={3}>{props.dataItem.NormalScoreText}</td></>) }} />
                                <Column title="5" />
                                <Column title="6" />
                            </Column>

                            <Column title="Positive" width="200px">
                                <Column title="7" field="NegativeScoreText" cell={(props) => {
                                    return (<><td colSpan={4}>{props.dataItem.PositiveScoreText}</td></>)
                                }} />
                                <Column title="8" />
                                <Column title="9" />
                                <Column title="10" footerCell={() => {
                                    return (<><td > Total </td></>)
                                }} />
                            </Column>

                            <Column field="Score" title="Score Enter 0-10" cell={StatusCell}
                                footerCell={() => {
                                    return (<><td> <input type="text" id="TotalScore" name={"TotalScore"} value={Total} /> </td></>)
                                }}  width="200px"/>
                            </SystemGrid>
                        </div>
                    )
                }}
            </scoreContext.Consumer>
        </>)
    }
};